import React from 'react';
import { Pairs } from '../../tradingPairs';
import TradingPairs from './TradingPairs';

function TradingBar() {

  

  return (
    <ul className="trading-list">
        {Pairs.map((item) => {
          return (
            <li className="trading-items"><a href="#" className="">{item.title}</a></li>
          );          
        })}     
    </ul>
  );
}

export default TradingBar;


            // <TradingPairs 
            //   items={item} 
            //   key={index}               
            // />